import { useMemo } from 'react';
import { useExerciseEditFormPagesRedirect } from '@features/exercises/exercise-form/model/helpres.ts';
import { getVideoSources } from '@shared/helpers/maps.tsx';
import { useMobile, usePlatformSettings } from '@shared/hooks';
import { SelectVideoModal } from '../select-video-modal';
import * as st from './styles.module.scss';

interface Props {
  onAddFromLibrary: () => void;
  startExerciseAdd: boolean;
  setStartExerciseAdd: React.Dispatch<React.SetStateAction<boolean>>;
}

export const AddExercise = ({
  onAddFromLibrary,
  startExerciseAdd,
  setStartExerciseAdd,
}: Props): JSX.Element => {
  const { isMobile } = useMobile();
  const { has_library } = usePlatformSettings();
  const videoSources = useMemo(
    () => getVideoSources(isMobile, has_library),
    [isMobile, has_library]
  );
  const { doRedirectWithSavePageUrl } = useExerciseEditFormPagesRedirect();

  const selectSource = (source: string) => {
    if (source === 'L') {
      onAddFromLibrary();
    } else {
      doRedirectWithSavePageUrl(`exercise/new?source=${source}`);
    }
    setStartExerciseAdd(false);
  };

  return (
    <SelectVideoModal isOpen={startExerciseAdd} onClose={() => setStartExerciseAdd(false)}>
      {videoSources.map((item, index) => (
        <li key={index} className={st.item} onClick={() => selectSource(item.videoType)}>
          <div>
            <div className={st.item__icon}>{item.icon}</div>
            <span>{item.text}</span>
          </div>
        </li>
      ))}
    </SelectVideoModal>
  );
};
